import { toast } from '@raystack/apsara';

export function locationErrorHandler(error) {
  if (typeof error === 'string') {
    toast.error('Browser Incompatible!', { description: error });
    return;
  }

  switch (error.code) {
    case error.PERMISSION_DENIED:
      toast.info('Need permissions!', {
        description:
          'Please allow location request from browser, in order change map location to your current location!'
      });
      break;
    case error.POSITION_UNAVAILABLE:
      toast.error('Location information is unavailable!', {
        description:
          'There seems to be an issue fetching browser current location. Please refresh or restart your browser!'
      });
      break;
    case error.TIMEOUT:
      toast.warning('The request to get user location timed out!', {
        description: 'Please try again!'
      });
      break;
    case error.UNKNOWN_ERROR:
      toast.error('Location information is unavailable!', {
        description:
          'There seems to be an issue fetching browser current location. Please refresh or restart your browser!'
      });
      break;
  }
}
